import { useSelector } from "react-redux";

import { authSelectors, useGetCompanyByHostQuery } from "@/store";
import { Role, Session } from "@/store/apis/_shared";

import { useWindowLocationHost } from "./useWindowLocationHost";

export function useSession() {
  const { company, ...session } = useSelector(authSelectors.session) as Session;
  const { role, isRoot } = session;

  const { windowLocationHost } = useWindowLocationHost();
  const { data: companyDataByHost } = useGetCompanyByHostQuery({ host: windowLocationHost }, { skip: !windowLocationHost || !company?.id });

  const isAdminRoot = role === Role.Administrador && isRoot;

  const sessionData = {
    ...session,
    company: {
      ...company,
      id: company?.id || companyDataByHost?.id || 0
    }
  };

  return {
    ...sessionData,
    isAdminRoot
  };
}
